import { field, date, relation, children,text } from '@nozbe/watermelondb/decorators';
import { GROUP_PAYMENT_SCHEMA } from '../schema';
import { Model } from '@nozbe/watermelondb';

export default class GROUPPAYMENTS extends Model {
    static table = GROUP_PAYMENT_SCHEMA;

    static associations = {
        groups: { type: 'belongs_to', key: 'group_id' },
        group_payment_ledger: { type: 'has_many', foreignKey: 'group_payment_id' },
    }

    @field('processed') processed;
    @field('amount') amount;
    @text('type') type;

    @date('collect_at') collect_at;

    @relation('groups', 'group_id') groups;

    @children('group_payment_ledger') group_payment_ledger;

};

